import { memo } from "react";

import { Text } from "@react/components/Text";
import { tw } from "classnames";

const styles = {
  base: tw("text-tertiary"),
};

const ReviewsFootnoteBase = () => {
  return (
    <Text as="caption" className={styles.base} size="xs">
      * Reviews are an aggregate of bundle components
    </Text>
  );
};

export const ReviewsFootnote = memo(ReviewsFootnoteBase);
